import React from 'react';
import { Link } from 'react-router-dom';
import FireflyEffect from '../components/FireflyEffect';
import '../styles/HomePage.css';
import { Helmet } from "react-helmet-async";

export default function HomePage() {

  //const baseUrl = window.location.origin;
  const baseUrl =
  process.env.NODE_ENV === "production"
    ? "https://grauconejo13-portfolio-backend.netlify.app"
    : window.location.origin; // for localhost testing

  return (
    <>
      <FireflyEffect />
      <main className="home-wrapper">
      <Helmet>
  <title>Vanessa Victorino | Developer, Designer & Creative Builder</title>
  <meta
    name="description"
    content="Hi, I'm Vanessa — a developer and designer exploring the intersection of code, creativity, and human insight. Welcome to my interactive portfolio."
  />
  <meta name="author" content="Vanessa Victorino" />
  <meta name="robots" content="index, follow" />

  {/* Open Graph / Facebook */}
  <meta property="og:title" content="Vanessa Victorino | Creative Developer Portfolio" />
  <meta
    property="og:description"
    content="Explore interactive projects, storytelling experiments, and real-world code by Vanessa Victorino."
  />
  <meta property="og:url" content={`${baseUrl}/`} />
  <meta property="og:type" content="website" />
  <meta property="og:image" content={`${baseUrl}/preview-home.jpg`} />

  {/* Twitter */}
  <meta name="twitter:card" content="summary_large_image" />
  <meta name="twitter:title" content="Vanessa Victorino | Developer & Designer" />
  <meta
    name="twitter:description"
    content="From experiments to elegance — view my evolving portfolio of creative and technical projects."
  />
  <meta name="twitter:image" content={`${baseUrl}/twitter-home.jpg`} />
</Helmet>
      
        <section className="home-hero">
          <h1>Hi, I'm Vanessa Victorino</h1>
          <p>I'm a software engineer passionate about design, creative coding, and intuitive experiences.</p>
        </section>

        <section className="home-cards">
          <div className="home-card">
            <h3>About Me</h3>
            <p>Learn how I transitioned from medical field to coding.</p>
            <Link to="/about">Read More →</Link>
          </div>

          <div className="home-card">
            <h3>Projects</h3>
            <p>Explore my projects blending creativity and functionality.</p>
            <Link to="/projects">View Projects →</Link>
          </div>

          <div className="home-card">
            <h3>Contact</h3>
            <p>Let’s connect and collaborate!</p>
            <Link to="/contact">Say Hello →</Link>
          </div>
        </section>
      </main>
    </>
  );
}
